import { cn } from "@omni/utils/styles";

import { SearchComponent } from "@/utils/search/types/searchComponent";

import { SearchPagination } from "./components/searchPagination/searchPagination";

type Props = {
    className?: string;
};

const ProductPagination = ({ className }: Props) => (
    <SearchPagination
        className={cn(className)}
        resultListComponent={SearchComponent.PRODUCT_RESULT_LIST}
        paginationComponent={SearchComponent.PRODUCT_PAGINATION}
        hitsPerPageComponent={SearchComponent.PRODUCT_HITS_PER_PAGE}
        numberOfHitsComponent={SearchComponent.PRODUCT_NUMBER_OF_HITS}
    />
);
const ContentPagination = ({ className }: Props) => (
    <SearchPagination
        className={cn(className)}
        resultListComponent={SearchComponent.CONTENT_RESULT_LIST}
        paginationComponent={SearchComponent.CONTENT_PAGINATION}
        hitsPerPageComponent={SearchComponent.CONTENT_HITS_PER_PAGE}
        numberOfHitsComponent={SearchComponent.CONTENT_NUMBER_OF_HITS}
    />
);

export const Pagination = {
    Product: ProductPagination,
    Content: ContentPagination
};
